module.exports = __webpack_public_path__ + "img/database.11bd2f97.png";